import { AbstractControl } from '@angular/forms';

export type ValidationMessageResolver = (error: unknown, control: AbstractControl) => string;
export type ValidationMessageMap = Record<string, string | ValidationMessageResolver>;

export function resolveControlErrorMessage(
  control: AbstractControl | null,
  messages: ValidationMessageMap
): string | null {
  if (!control?.errors) {
    return null;
  }

  for (const [errorKey, message] of Object.entries(messages)) {
    if (!control.hasError(errorKey)) {
      continue;
    }

    const errorValue = control.errors[errorKey];
    return typeof message === 'function'
      ? message(errorValue, control)
      : message;
  }

  return null;
}
